import { Component, Input, OnInit } from '@angular/core';

import { Lesson, SchoolSubject, StudentClass } from '@df/interfaces';

@Component({
    selector: 'app-stat-lesson-info',
    templateUrl: './stat-lesson-info.component.html',
    styleUrls: ['./stat-lesson-info.component.scss']
})
export class StatLessonInfoComponent implements OnInit {
    @Input() lesson: Lesson;
    @Input() subject: SchoolSubject;
    @Input() student_class: StudentClass;
    @Input() data;

    constructor() {}

    ngOnInit() {}
}
